"use client";

import { motion } from "framer-motion";
import { Download } from "lucide-react";
import { trackCTAClick, trackStoreClick } from "@/app/lib/analytics";
import { PLAY_STORE_URL } from "@/app/lib/constants";

export default function DownloadCTA() {
  return (
    <section
      id="download"
      data-section="section-download"
      className="relative py-32 sm:py-44 overflow-hidden"
      aria-label="Descargar Finbo"
    >
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="ambient-glow" />
        <div className="ambient-noise" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <motion.div
          data-particle-shield
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2 className="text-[clamp(44px,8vw,108px)] font-black leading-[0.95] tracking-tight mb-6">
            Empezá <span className="text-primary">hoy.</span>
          </h2>
          <p className="text-white/65 text-lg sm:text-xl max-w-xl mx-auto mb-10 leading-relaxed">
            Bajá Finbo gratis. Son cinco minutos para registrarte y empezar
            a ver tu plata con claridad.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-6">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-base !py-4 !px-9"
              onClick={() => {
                trackCTAClick("final_download", "final_cta");
                trackStoreClick("play_store", "final_cta");
              }}
            >
              <Download size={18} />
              Descargar en Google Play
            </a>
          </div>
          <p className="text-white/35 text-xs">
            Disponible en Google Play
          </p>
        </motion.div>
      </div>
    </section>
  );
}
